import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const STATUS = Object.freeze({
  IDLE: 'idle',
  ERROR: 'error',
  LOADING: 'loading'
});

const initialState = {
  loadingStatus: STATUS.IDLE,
  faqsData: [],
  faqSpecializationData: [],
  isOpenModal: false,
  isStatusOpenModal: false,
  totalFaq: 0,
}

export const faqsSlice = createSlice({
  name: "faqs",
  initialState,
  reducers: {
    setFaqsData(state, { payload }) {
      state.faqsData = payload.result
      state.totalFaq = payload.count
    },
    updateFaqsData(state, { payload }) {
      const objIndex = state.faqsData.findIndex((obj) => obj.id === payload.id);
      if (objIndex >= 0) {
        state.faqsData[objIndex] = payload
      }
    },
    pushFaqs(state, { payload }) {
      state.faqsData.push(payload)
      state.totalFaq += 1
    },
    sliceFaqsData(state, { payload }){
      const objIndex = state.faqsData.findIndex((obj) => obj.id === payload);
      state.faqsData = state.faqsData.slice(0, objIndex)
      state.totalFaq -= 1
    },
    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setFaqsData, updateFaqsData, pushFaqs, isOpenModal, ModalToggle, sliceFaqsData } = faqsSlice.actions;

export default faqsSlice.reducer;

export function getFaqs(limit, offset) {
  return async function getFaqsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getFaqs(limit, offset).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setFaqsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addFaqs(payload) {
  return async function addFaqsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addFaqs(payload).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(pushFaqs(response.data))
          dispatch(ModalToggle())
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateFaqs(payload) {
  return async function updateFaqsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.updateFaqs(payload.id, payload).then(
        (response) => {
          dispatch(updateFaqsData(response.data))
          dispatch(setLoading(false))
          dispatch(ModalToggle())
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function deleteFaqs(id) {
  return async function deleteFaqsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteFaqs(id).then(
        (response) => {
          dispatch(sliceFaqsData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

